/**
 * schema/proposal.ts — AI proposal contract (review queue).
 */
export interface Proposal {
  id: string;
  motion: string;
  /** pending | rejected (drives the Active/Deactivated vs Rejected tabs). */
  status?: string;
  /** 0..1 model confidence. */
  confidence: number;
  /** Plain-English "what this rule does" (shown first). */
  intent: string;
  rationale: string;
  /** What the suggestion is drawn from. */
  from: { category?: string; relation?: string };
  /** The category that fires the rule (cart_contains_category) — carried so
   *  "Edit" can pre-fill the Rule Builder with the proposal's real trigger. */
  triggerCategory?: string;
  /** The category that suppresses the rule (cart_not_contains_category). */
  excludeCategory?: string;
  /** Suggested phrasing template, e.g. "Add a {item_name} with that?". */
  phrasing?: string;
  /** Each category named in the rule → real example items, so the operator sees
   *  what "Mains" / "Sides" actually contain (concrete preview). */
  categoryExamples?: Array<{ name: string; items: string[] }>;
  select: string;
  maxPriceDelta: number;
  /** True when a target item/category was deactivated or deleted in Catalog, so
   *  approving this now would create a rule that can't make suggestions. */
  stale?: boolean;
  /** Plain-English reason the proposal is out of date (shown on the card). */
  staleReason?: string;
  /** Transient UI flag for the approve/reject fly-out animation. */
  exiting?: boolean;
}

/** Reassurance guard chips rendered on each proposal card. */
export function proposalGuards(p: Proposal): string[] {
  return ['Availability', 'Dietary-safe', `≤${p.maxPriceDelta}% price`];
}
